import { useState } from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import classNames from 'classnames';
import { FormProvider, useForm } from 'react-hook-form';
import useAuth from "../useAuth";
import Field from "../components/form/Field";
import {showErrorNotification} from "../util/notifications";
import {routes} from "../routes/routes";
import {ReactComponent as KilnLogoSVG} from '../../img/kiln_logo.svg';
import {ReactComponent as TheVideoGramSVG} from '../../img/thevideogram.svg';
import useApi from "../api";

const LoginView = () => {
    const loginStates = {
        login: 'LOGIN',
        startReset: 'START_RESET',
        resetRequested: 'RESET_REQUESTED',
    };
    const {requestResetPassword} = useApi();
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState(loginStates.login);
    const auth = useAuth();
    const history = useHistory();
    const location = useLocation();
    const fromFallback = { from: { pathname: routes.reports } };
    const { from } = location.state || fromFallback;
    const formMethods = useForm();
    const { handleSubmit, getValues } = formMethods;

    const onSubmit = (data) => {
        setLoading(true);
        auth.signIn(data, onLoginSuccess, onLoginFailed);
    }

    const onLoginSuccess = () => {
        history.push(from);
    }

    const onLoginFailed = (error) => {
        showErrorNotification(error);
        setLoading(false);
    }

    const onError = (error) => {
        console.log(error);
        showErrorNotification('Login failed.');
    }

    const onShowPasswordReset = (e) => {
        e.preventDefault();
        setState(loginStates.startReset);
    }

    const onHidePasswordReset = (e) => {
        e.preventDefault();
        setState(loginStates.login);
        setMessage(null);
    }

    const onPasswordReset = async (e) => {
        setLoading(true);
        e.preventDefault();
        const username = getValues('username');
        console.log(username);
        try {
            await requestResetPassword(username);
            setLoading(false);
            setState(loginStates.resetRequested);
            setMessage('If your account exists, you will receive an email to set a new password.');
        } catch (e) {
            setLoading(false);
            setState(loginStates.startReset);
            setMessage('Something went wrong. Please try again later.');
        }
    };

    const resetLoginView = () => {
        setMessage(null);
        setState(loginStates.login)
    }

    const buttonClass = classNames('button', 'button--secondary', {
        'button--loading': loading,
    });

    return (
        <div className="login">
            <div className="login__header">
                <KilnLogoSVG className="login__logo" />
            </div>
            <div className="login__box">
                <FormProvider {...formMethods} >
                    <form onSubmit={handleSubmit(onSubmit, onError)} noValidate className="form">
                        {message ? (
                            <div className="notification notification--inline">{message}</div>
                        ) : null}
                        {state === loginStates.login || state === loginStates.startReset ? (
                            <>
                                <Field
                                    defaultValue=""
                                    type="text"
                                    name="username"
                                    label="Email"
                                    placeholder="Email"
                                />
                                {state === loginStates.login ? (
                                    <Field
                                        defaultValue=""
                                        type="password"
                                        name="password"
                                        label="Password"
                                        placeholder="Password"
                                    />
                                ) : null}
                                <div className="button__bar">
                                    {state === loginStates.login ? (
                                        <>
                                            <button className={buttonClass}>Sign in</button>
                                            <button className="button button--link" onClick={onShowPasswordReset}>Forgot password?</button>
                                        </>
                                    ) : state === loginStates.startReset ? (
                                        <>
                                            <button className={buttonClass} onClick={onPasswordReset}>Reset password</button>
                                            <button className="button button--link" onClick={onHidePasswordReset}>Cancel</button>
                                        </>
                                    ) : null}
                                </div>
                            </>
                        ) : state === loginStates.resetRequested ? (
                            <div className="button__bar">
                                <button className="button button--secondary" onClick={resetLoginView}>Back to sign in</button>
                            </div>
                        ) : null}
                    </form>
                </FormProvider>
            </div>
            <div className="login__footer">
                <a href="https://thevideogram.nl" target="_blank" rel="noopener noreferrer">
                    <TheVideoGramSVG className="login__footer-logo" />
                    <span className="login__footer-text">A product of TheVideoGram</span>
                </a>
            </div>
        </div>
    )
};

export default LoginView;
